import { ConnectedIncidentsTable } from "fleet/controller/incidents/connected-incidents-table";
import startCase from "lodash/startCase";
import PropTypes from "prop-types";
import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import { Badge } from "view/layout/sidebar";

class TabbedIncidentsTable extends React.PureComponent {
  static get propTypes() {
    return {
      condensed: PropTypes.bool,
      resolveMsgHandler: PropTypes.func,
      showDeviceNames: PropTypes.bool,
      showCount: PropTypes.bool,
      sizePerPage: PropTypes.number,
      sizePerPageList: PropTypes.arrayOf(
        PropTypes.shape({
          text: PropTypes.string.isRequired,
          value: PropTypes.number.isRequired,
        }),
      ),
      tableData: PropTypes.array.isRequired,
    };
  }

  static get defaultProps() {
    return {
      condensed: false,
      resolveMsgHandler: () => {},
      showDeviceNames: false,
      showCount: false,
      sizePerPage: 10,
      sizePerPageList: null,
    };
  }

  static _filterTableData(tableData, key) {
    const matchValue = key === "resolved";

    return tableData.filter((incident) => {
      return incident.resolved === matchValue;
    });
  }

  constructor(props) {
    super(props);

    this.defaultActiveKey = "unresolved";
    this.badgeColors = {
      resolved: "green",
      unresolved: "red",
    };

    this.state = {
      counts: {},
      activeTab: this.defaultActiveKey,
      filteredTableData: this.constructor._filterTableData(
        props.tableData,
        this.defaultActiveKey,
      ),
    };

    this._formatTabTitle = this._formatTabTitle.bind(this);
    this._setTableState = this._setTableState.bind(this);
  }

  componentDidMount() {
    const { activeTab } = this.state;
    this._setTableState(this.props, activeTab);
  }

  componentDidUpdate(prevProps) {
    const { activeTab } = this.state;
    if (prevProps.tableData !== this.props.tableData) {
      this._setTableState(this.props, activeTab);
    }
  }

  _getIncidentCounts(data) {
    const resolvedCount = data.filter((incident) => incident.resolved).length;
    return {
      resolved: resolvedCount,
      unresolved: data.length - resolvedCount,
    };
  }

  _onTabSelectSetState(tableData, key) {
    const newState = {
      activeTab: key,
      filteredTableData: this.constructor._filterTableData(tableData, key),
    };
    this.setState(newState);
  }

  _setTableState(props, activeTab) {
    const { tableData } = props;
    this.setState({
      counts: props.showCount ? this._getIncidentCounts(tableData) : {},
      filteredTableData: this.constructor._filterTableData(
        tableData,
        activeTab,
      ),
    });
  }

  _formatTabTitle(key) {
    const { showCount } = this.props;
    const count = this.state.counts[key];
    return (
      <span>
        {startCase(key)}{" "}
        {showCount && count !== undefined && count !== null && (
          <Badge color={this.badgeColors[key]} text={String(count)} />
        )}
      </span>
    );
  }

  render() {
    const { tableData, ...props } = this.props;
    const { filteredTableData } = this.state;

    const unresolvedTitle = this._formatTabTitle("unresolved");
    const resolvedTitle = this._formatTabTitle("resolved");
    return (
      <Tabs
        defaultActiveKey={this.defaultActiveKey}
        className="nav-tabs-custom tabbed-incidents-table"
        animation="false"
        onSelect={this._onTabSelectSetState.bind(this, tableData)}
        id="tabbed-incidents-table"
      >
        <Tab eventKey="unresolved" title={unresolvedTitle}>
          <ConnectedIncidentsTable {...props} tableData={filteredTableData} />
        </Tab>
        <Tab eventKey="resolved" title={resolvedTitle}>
          <ConnectedIncidentsTable {...props} tableData={filteredTableData} />
        </Tab>

      </Tabs>
    );
  }
}

export { TabbedIncidentsTable };
